import type { FC } from "react";

import {
  GTG_SNIPPET,
  GTM_NOSCRIPT_IFRAME,
  GTM_ROUTE_CHANGE_EVENT,
} from "@/constants/googleTagManager";

// ルート直下の gatsby-ssr.tsx / gatsby-browser.ts は biome の対象外
// （package.json の format / format:check は ./src 限定）なので、
// ロジックはこちらに置いてルート側は呼び出しだけにする

/**
 * GTM を注入するかどうか
 * @note `gatsby build` は GATSBY_ENV に関わらず NODE_ENV=production になるため、
 * dev / stg / VRT ビルドでも注入される。抑止されるのは `gatsby develop` のみで、
 * これは削除した gatsby-plugin-google-tagmanager の条件と同じ
 */
const isGtmEnabled = (): boolean => process.env.NODE_ENV === "production";

/** GTM ローダー。head に差し込む */
export const GtmScript: FC = () =>
  isGtmEnabled() ? (
    <script
      // biome-ignore lint/security/noDangerouslySetInnerHtml: 埋め込むのはビルド時に確定する定数のみでユーザー入力を含まないため
      dangerouslySetInnerHTML={{ __html: GTG_SNIPPET }}
    />
  ) : null;

/**
 * noscript フォールバック。body 直後に差し込む
 */
export const GtmNoscript: FC = () =>
  isGtmEnabled() ? (
    <noscript
      // biome-ignore lint/security/noDangerouslySetInnerHtml: 埋め込むのはビルド時に確定する定数のみでユーザー入力を含まないため
      dangerouslySetInnerHTML={{ __html: GTM_NOSCRIPT_IFRAME }}
    />
  ) : null;

/**
 * ルート遷移を dataLayer に通知する
 * @note
 * - 50ms 待つのは document.title の更新後に push する必要があるため
 * - GTM のロードに失敗しても push で落ちないよう dataLayer を初期化する
 */
export const pushRouteChangeEvent = (): void => {
  if (!isGtmEnabled()) {
    return;
  }

  setTimeout(() => {
    window.dataLayer ??= [];
    window.dataLayer.push({ event: GTM_ROUTE_CHANGE_EVENT });
  }, 50);
};
